// @dynamic-i18n-keys
// Dynamic t() at line 24: label is 'poll.thumb.overlay.vote' or 'poll.thumb.overlay.viewResults'.
//   poll.thumb.overlay.vote
//   poll.thumb.overlay.viewResults
import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import PollDuperbrowseLink from './PollDuperbrowseLink';

export interface Props {
  className?: string;
  deviation: PapiDeviation;
  isOwner: boolean;
}

class PollOverlay extends React.Component<Props & WithTranslation> {
  render() {
    const { className, deviation, isOwner, t } = this.props;

    let label = 'poll.thumb.overlay.vote';
    if (isOwner || (deviation.poll && deviation.poll.hasVoted)) {
      label = 'poll.thumb.overlay.viewResults';
    }

    return (
      <div className={className}>
        <PollDuperbrowseLink deviation={deviation}>{t(label)}</PollDuperbrowseLink>
      </div>
    );
  }
}

export default withTranslation()(PollOverlay) as React.ComponentType<Props>;
